import React from "react";
import { ParallaxArtWrapper } from "../three/ParallaxArtWrapper";

export function HomePage() {
    return <ParallaxArtWrapper/>;
}
